import type { Prismic } from '@landsbankinn/prismic';
import {
  fallbackImage,
  fallbackRichText,
  fallbackText,
  getDataFromLink,
  isEmptyText,
  PrismicLink,
  PrismicText,
} from '@landsbankinn/prismic';

import { Segment } from '@landsbankinn/ui';
import React, { useContext } from 'react';
import { Card } from '../components/card/Card';
import { TextWithRelated } from '../components/slices/TextWithRelated';

interface IProps {
  copy: Prismic.RichText;
  fields: IField[];
  template: string;
}

interface IField {
  image?: Prismic.Image;
  title: Prismic.RichText;
  copy: Prismic.RichText;
  link_text: Prismic.RichText;
  link?: Prismic.Link;
}

const renderRelatedItem = ({ image, title, copy, link }: IField, i: number) => {
  const linkdata = getDataFromLink(link);
  const cardTitle = fallbackText(title, linkdata.title ?? undefined);
  const img =
    !!image || !!link
      ? fallbackImage(image as any, linkdata.image ?? undefined)
      : null;
  return (
    <Card
      key={`card-${i}`}
      link={link}
      title={
        link ? (
          <PrismicLink value={link} title={cardTitle ?? undefined}>
            <a>{cardTitle}</a>
          </PrismicLink>
        ) : (
          cardTitle
        )
      }
      description={fallbackRichText(copy, linkdata.abstract ?? undefined)}
      image={img ?? undefined}
      ar="ar_1_1"
      padding={false}
      backgroundAlt={false}
      notLink={!link}
    />
  );
};

export const TextWithRelatedContainer = ({
  copy,
  fields,
  template,
}: IProps) => {
  if (isEmptyText(copy)) {
    return null;
  }

  const isArticle = template === 'article';

  return (
    <Segment isArticle={isArticle}>
      <TextWithRelated
        cards={fields?.map(renderRelatedItem)}
        isArticle={isArticle}
      >
        <PrismicText value={copy} isArticle={isArticle} />
      </TextWithRelated>
    </Segment>
  );
};
